import '../../style/';
import './index.less';



/** WEBPACK FOOTER **
 ** ./components/accordion/style/index.web.tsx
 **/